<template>
  <div class="">
    <div class="vtgMultiTab">
      <ul class="col2">
        <li :class="{'on': tabSelected=='prods'}">
          <a @click="tabSelected='prods'"><span>사용가능({{prodsUnused.count}}장)</span></a>
        </li>
        <li :class="{'on': tabSelected=='used'}">
          <a @click="tabSelected='used'"><span>사용완료/만료({{prodsUsed.count}}장)</span></a>
        </li>
      </ul>
    </div>

    <div class="contArea coupon" v-if="onload">
      <subsc-prod-list-item v-show="tabSelected=='prods'" :prods="prodsUnused.items"/>
      <subsc-prod-list-item v-show="tabSelected=='used'" :prods="prodsUsed.items" :subscId="subscId" :used="true"/>
    </div>

    <!-- 에러 popup -->
    <popup-alert v-if="alertActivate" title="알림" @close="closeAlert">
      {{alertMsg}}
    </popup-alert>

  </div>
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";

  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import SubscProdListItem from "./SubscProdListItemView";

  export default {
    components: {
      PopupAlert,
      SubscProdListItem,
    },

    created() {
      this.getSubscProds(this.subscId);
    },

    data() {
      return {
        alertActivate: false,
        onload: false,
        prodsUnused: { count: 0, items: [], },
        prodsUsed: { count: 0, items: [], },
        tabSelected: 'prods',
      };
    },

    methods: {
      closeAlert() {
        this.alertActivate = false;
        this.$router.push('/');
      },

      getSubscProds(subscId) {
        Object.assign(this.$data, this.$options.data());
        if (subscId) {
          this.$store.commit('setBtnLoading', true);
          this.onload = false;
          axios.get(`${api.subscs}/showProdsV2/${subscId}`)
            .then(({data}) => {
              this.prodsUnused.items = data.data.able;
              this.prodsUnused.count = data.data.able.length;
              this.prodsUsed.items = data.data.disable;
              this.prodsUsed.count = data.data.disable.length;
              this.onload = true;
            })
            .catch((error) => {
              if(error.response.status == 401) {
                this.$store.commit('setPopup401', true);
              } else {
                this.alertMsg = this.errorMsg(error);
                this.alertActivate = true;
              }
            });
        } else {
          this.onload = true;
        }
      },
    },

    props: {
      subscId: Number,
    },

    watch: {
      subscId(value) {
        this.getSubscProds(value);
      },
    },
  };
</script>